import { useCallback, useState } from "react";

/**
 * Filter-Tab mit optionaler sessionStorage-Persistenz.
 * @param {string[]} allowedValues
 * @param {string} storageKey
 * @param {string} [fallback="all"]
 */
export function usePersistedFilter(
  allowedValues,
  storageKey,
  fallback = "all",
) {
  const readStored = () => {
    if (!storageKey) return null;
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (allowedValues.includes(raw)) return raw;
    } catch {
      /* ignore */
    }
    return null;
  };

  const stored = readStored();
  const [filter, setFilter] = useState(stored || fallback);
  const [filterReady, setFilterReady] = useState(Boolean(stored));

  const selectFilter = useCallback(
    (value) => {
      setFilter(value);
      setFilterReady(true);
      if (!storageKey) return;
      try {
        sessionStorage.setItem(storageKey, value);
      } catch {
        /* ignore */
      }
    },
    [storageKey],
  );

  return { filter, setFilter, filterReady, setFilterReady, selectFilter };
}
